<div class="oee-modal" [ngClass]="[sizeClass, tintClass]">
    <!-- Modal Header (locked structure) -->
    <div class="modal-header">
        <div class="header-top-row">
            <div class="header-icon" [ngClass]="iconColorClass">
                @if (useMaterialIcon) {
                    <mat-icon>{{ icon }}</mat-icon>
                } @else {
                    <i [class]="iconClass"></i>
                }
            </div>
            <h2 mat-dialog-title>
                {{ title }}@if (contextName) {<span class="context-separator">: </span><span class="context-name">{{ contextName }}</span>}
            </h2>
            <button class="close-btn" mat-dialog-close (click)="onClose()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        @if (subtitle) {
            <p class="subtitle">{{ subtitle }}</p>
        }
    </div>

    <!-- Modal Content -->
    <mat-dialog-content [style.max-height]="contentMaxHeight">
        <!-- Loading State -->
        @if (loading) {
            <div class="loading-state">
                <div class="spinner"></div>
                <p>{{ loadingMessage }}</p>
            </div>
        } @else {
            <!-- Projected Content -->
            <ng-content select="[modal-content]"></ng-content>
        }
    </mat-dialog-content>

    <!-- Modal Actions (locked structure, projected buttons) -->
    <mat-dialog-actions align="end">
        <ng-content select="[modal-actions]"></ng-content>
    </mat-dialog-actions>
</div>
